import { Column } from "primereact/column";
import { DataTable } from "primereact/datatable";
import { Menu } from "primereact/menu";
import * as React from "react";
import { useRef, useState } from "react";
import { useTranslation } from "react-i18next";
import { CoreConstants } from "../../../../core/models/constants/core.constants";
import PrwcGlobalFilter from "../PrwcGlobalFilter";
import "./PrwcDataTableAdvanced.scss";

const PrwcDataTableAdvanced = (props: any) => {
  const {
    data,
    columns,
    noOfRows = CoreConstants.Data.table.paginator.rows,
    rowsPerPageOptions = CoreConstants.Data.table.paginator.rowsPerPageOptions,
    paginator = false,
    onEdit,
    onDelete
  } = props;
  const { t } = useTranslation();
  const [globalSearch, setGlobalSearch] = useState("");
  const menuRef: any = useRef(null);
  let selectedRowData: any = null;

  const handleGlobalSearch = (value: string) => {
    setGlobalSearch(value);
  };

  const menuItems = [
    {
      label: t("generic.action.edit"),
      icon: "pi pi-pencil",
      command: () => {
        onEdit(selectedRowData);
      },
    },
    {
      label: t("generic.action.delete"),
      icon: "pi pi pi-trash",
      command: () => {
        onDelete(selectedRowData);
      },
    },
  ];

  const handleOnMenuClick = (event: any, rowData: any) => {
    if (menuRef && menuRef.current) {
      menuRef.current.toggle(event);
      selectedRowData = rowData;
    }
  }

  const actionTemplate = (rowData: any) => {
    return (
      <div className="ml-2 lg:ml-0">
        <i
          className="text-xs cursor-pointer pi pi-ellipsis-v"
          onClick={(event: any) => handleOnMenuClick(event, rowData)}
        ></i>
      </div>
    );
  };

  return (
    <div className="prw-datatable-advanced">
      <div className="flex items-center w-full pb-2 mr-1 rounded-t-xl">
        <div className="flex-1">
          <PrwcGlobalFilter
            value={globalSearch}
            onChange={handleGlobalSearch}
            className="w-full h-10 rounded-lg"
          ></PrwcGlobalFilter>
        </div>
      </div>
      <Menu model={menuItems} popup ref={menuRef} className="w-32 prw-datatable-advanced-action-menu" />
      <DataTable
        globalFilter={globalSearch}
        value={data}
        paginator={paginator}
        rows={noOfRows}
        rowsPerPageOptions={rowsPerPageOptions}
        className="p-datatable-responsive"
      >
        {columns &&
          columns.map((column: any) => (
            <Column
              key={column.field}
              field={column.field}
              header={t(column.headerLabelKey)}
              body={(props: any) =>
                column["bodyTemplate"](
                  props[column.templateArgument ?? column.field],
                  t(column.headerLabelKey),
                  column?.command,
                  props
                )
              }
              className={column.className}
              sortable={column.sortable ?? false}
            ></Column>
          ))}
        <Column
          field="action"
          body={(props: any) => actionTemplate(props)}
          className="w-px text-xs"
        ></Column>
      </DataTable>
    </div>
  );
};

export default PrwcDataTableAdvanced;
